<div class="modal-header">
    <h4 class="modal-title">Solicitar cr&eacute;dito comercial</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" [disabled]="guardando" (click)="onCancelar()" aria-label="Cerrar"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
      <div class="leyenda">
        <small>*Los montos aqu&iacute; expresados son en ARP</small>
      </div>
        <div class="row fw-bold text-center my-2">
            <div class="col-3"></div>
            <div class="col-3">Monto</div>
            <div class="col-3">Fecha Desde</div>
            <div class="col-3">Fecha Hasta</div>
        </div>

        <div class="row align-items-center mb-3">
            <div class="col-3 ps-4">
                <label class="col-form-label">Excedido Autorizado</label>
            </div>
            <div class="col-3">
                <input class="form-control" formControlName="excedidoAutorizado" appOnlyNumber/>
            </div>
            <div class="col-3">
                <div class="input-group">
                    <input
                    type="date"
                    class="form-control"
                    placeholder="aaaa-mm-dd"
                    formControlName="fechaDesdeFormControlExcedido"
                    [minDate]="calendar.getToday()"
                    ngbDatepicker
                    #dExcedidoDesde="ngbDatepicker"
                    ngbTooltip="Seleccione una fecha."
                    readonly/>
                    <button class="btn btn-secondary" (click)="dExcedidoDesde.toggle()">
                        <i class="fa fa-calendar"></i>
                    </button>
                </div>
            </div>
            <div class="col-3">
                <div class="input-group">
                    <input
                    type="date"
                    class="form-control"
                    placeholder="aaaa-mm-dd"
                    formControlName="fechaHastaFormControlExcedido"
                    [minDate]="calendar.getToday()"
                    ngbDatepicker
                    #dExcedidoHasta="ngbDatepicker"
                    ngbTooltip="Seleccione una fecha."
                    readonly/>
                    <button class="btn btn-secondary" (click)="dExcedidoHasta.toggle()">
                        <i class="fa fa-calendar"></i>
                    </button>
                </div>
            </div>
        </div>
        @if (form.get('fechaHastaFormControlExcedido')?.hasError('rangoInvalido')) {
          <div class="row align-items-center mb-3 justify-content-end">
            <div class="col-6 text-center order-last">
              <ngb-alert type="warning" [dismissible]="false" class="alert alert-danger">
                Fecha desde no puede ser mayor a fecha hasta
              </ngb-alert>
            </div>
          </div>
        }
        <div class="row align-items-center mb-3">
            <div class="col-3 ps-4">
                <label class="col-form-label">Vencido Autorizado</label>
            </div>
            <div class="col-3">
                <input class="form-control" formControlName="vencidoAutorizado" appOnlyNumber/>
            </div>
            <div class="col-3">
                <div class="input-group">
                    <input
                    type="date"
                    class="form-control"
                    placeholder="aaaa-mm-dd"
                    formControlName="fechaDesdeFormControlVencido"
                    ngbDatepicker
                    [minDate]="calendar.getToday()"
                    #dVencidoDesde="ngbDatepicker"
                    ngbTooltip="Seleccione una fecha."
                    readonly/>
                    <button class="btn btn-secondary" (click)="dVencidoDesde.toggle()">
                        <i class="fa fa-calendar"></i>
                    </button>
                </div>
            </div>
            <div class="col-3">
                <div class="input-group">
                    <input
                    type="date"
                    class="form-control"
                    placeholder="aaaa-mm-dd"
                    formControlName="fechaHastaFormControlVencido"
                    [minDate]="calendar.getToday()"
                    ngbDatepicker
                    #dVencidoHasta="ngbDatepicker"
                    ngbTooltip="Seleccione una fecha."
                    readonly/>
                    <button class="btn btn-secondary" (click)="dVencidoHasta.toggle()">
                        <i class="fa fa-calendar"></i>
                    </button>
                </div>
            </div>
        </div>
        @if (form.get('fechaHastaFormControlVencido')?.hasError('rangoInvalido')) {
          <div class="row align-items-center mb-3 justify-content-end">
            <div class="col-6 text-center order-last">
              <ngb-alert type="warning" [dismissible]="false" class="alert alert-danger">
                Fecha desde no puede ser mayor a fecha hasta
              </ngb-alert>
            </div>
          </div>
        }
        <div class="row align-items-center mb-3">
            <div class="col-3 ps-4">
                <label for="observacionesFormControl" class="form-label">Observaciones</label>
            </div>
            <div class="col-6">
                <textarea
                    id="observacionesFormControl"
                    class="form-control"
                    rows="3"
                    placeholder=""
                    formControlName="observacionesFormControl"
                ></textarea>
                <div class="alert alert-danger mt-2"
                    *ngIf="form.get('observacionesFormControl')?.touched && form.get('observacionesFormControl')?.invalid">
                    Requerido
                </div>
            </div>
        </div>
    </form>
</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onGuardar()" [disabled]="mensajeVacio() || form.invalid || (!vencidoAutorizado.value && !excedidoAutorizado.value) || guardando">
      <div *ngIf="!guardando">
        <span>Solicitar Cr&eacute;dito</span>
      </div>
      <div *ngIf="guardando" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Guardando...</span>
      </div>
    </button>
    <button type="button" class="btn btn-secondary" [disabled]="guardando" (click)="onCancelar()">Cancelar</button>
</div>
